import { DATA } from '@wix/component-protocol/schema';
import { NativeActionsList } from '@wix/editor-platform-host-integration-apis';
export const ACTION_NAME_TO_DATA_TYPE = {
  [NativeActionsList.link]: DATA.DATA_TYPE.link,
  [NativeActionsList.editText]: DATA.DATA_TYPE.text,
  [NativeActionsList.editRichText]: DATA.DATA_TYPE.richText,
  [NativeActionsList.richTextAlignment]: DATA.DATA_TYPE.richText,
  [NativeActionsList.richTextBold]: DATA.DATA_TYPE.richText,
  [NativeActionsList.richTextDirection]: DATA.DATA_TYPE.richText,
  [NativeActionsList.richTextFontFamily]: DATA.DATA_TYPE.richText,
  [NativeActionsList.richTextFontSize]: DATA.DATA_TYPE.richText,
  [NativeActionsList.richTextForeColor]: DATA.DATA_TYPE.richText,
  [NativeActionsList.richTextItalic]: DATA.DATA_TYPE.richText,
  [NativeActionsList.richTextPanel]: DATA.DATA_TYPE.richText,
  [NativeActionsList.richTextStrikethrough]: DATA.DATA_TYPE.richText,
  [NativeActionsList.richTextUnderline]: DATA.DATA_TYPE.richText
};
//# sourceMappingURL=constants.js.map